import { useState } from 'react'
import Armar from './armar.js'
import Cobrar from './cobrar.js'

const Pileta = (props) => {
    const [cobrar, setCobrar] = useState(false)

    const formato_e = 'text-red-600'
    const formato_noe = 'text-zinc-800'


    return (<>
        <div className='flex flex-col justify-center w-full border-b-2 border-zinc-800'>
            <label className='flex justify-center text-lg'>Temporada 2026 / 2027</label>
            <div className='flex justify-center w-full'>
                <div className='w-1/2 flex flex-row justify-between text-lg'>
                    <label className={cobrar ? formato_noe : formato_e} onClick={e => setCobrar(false)}>Armar plan</label>
                    <label className={cobrar ? formato_e : formato_noe} onClick={e => setCobrar(true)}>Cobrar</label>
                </div>
            </div>
        </div>
        {!cobrar && <Armar back={props.back} token={props.token} />}
        {cobrar && <Cobrar back={props.back} token={props.token} />}


    </>)
}

export default Pileta